module.exports = __webpack_public_path__ + "static/img/2.d7b0a02.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/3/eng/2.png
// module id = nm5g
// module chunks = 0